<template>
  <!-- hh_code -->
  <div>
    <!-- <div>
      
    </div> -->
    <div class="box rounded-md shadow-md">
      <div class="flex justify-end mx-6 pt-2" v-if="isFamProfile">
        <!-- <div
          class="px-3 py-2 bg-theme-37 text-white inline-block rounded-md rounded-tl-none rounded-br-none"
        >
          {{ information.fam_type ? information.fam_type.desc : "ไม่มีข้อมูล" }}
        </div> -->
        <button
          class="btn btn-danger mr-2"
          @click="deleteProfile"
          data-test="delete-family-modal"
          v-if="(!getMemberData.is_hh_head && (currentUser == information?.case_manager?.uid || currentUser == information?.volunteer.uid)) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('delete-family'))"
        >
          <Trash2Icon class="h-3 w-3 mr-2" />
          ลบ
        </button>
        <button
          class="btn btn-primary"
          @click="openEditFamilyModal"
          data-test="edit-family-modal"
          v-if="(currentUser == information?.case_manager?.uid || currentUser == information?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-family'))"
        >
          <Edit2Icon class="h-3 w-3 mr-2" />
          แก้ไข
        </button>
      </div>
      <div class="flex justify-end mx-6 pt-2" v-if="isFamProfile == false">
        <!-- <AddHouseHoldModal
          :addHouseholdModal="addHouseholdModal"
          :editModal="editModal"
          @modal-value="clearValue"
        /> -->
        <button
          class="btn btn-danger mr-2"
          @click="deleteProfile"
          data-test="delete-household-modal"
          v-if="(currentUser == information?.case_manager?.uid || currentUser == information?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('delete-household'))"
        >
          <Trash2Icon class="h-3 w-3 mr-2" />
          ลบ
        </button>
        <button
          class="btn btn-primary"
          @click="openEditFamilyModal"
          data-test="edit-household-modal"
          v-if="(currentUser == information?.case_manager?.uid || currentUser == information?.volunteer.uid) || (getCurrentRole() != 'cm' && getCurrentRole() != 'vt' && getAllowActionByCurrRole('edit-household'))"
        >
          <Edit2Icon class="h-3 w-3 mr-2" />
          แก้ไข
        </button>
      </div>
      <!-- <AddFamilyModal
          :addFamilyModal="addFamilyModal"
          :addressData="information"
          :editModal="editModal"
          @modal-value="clearValue"
        /> -->
      <div class="p-5 flex flex-wrap justify-center">
        <div class="flex-shrink-0 mx-8 flex flex-col items-center mb-5">
          <!-- <div class="bg-theme-33 rounded-full h-28 w-28 mb-2"> -->
            <!-- <img v-if="getMemberData.image" :src="getMemberData.image.img_url" class="object-cover object-center h-full"/> -->
          <!-- </div> -->
          <div 
            class="relative h-28 w-28 rounded-full p-1 mb-2 flex-shrink-0" 
            :class="{'bg-theme-41': getMemberData.sex === 'ชาย','bg-theme-36': getMemberData.sex === 'หญิง'}"
          >
            <div class="h-full w-full rounded-full bg-theme-33 border-4 border-white overflow-hidden">
              <img v-if="getMemberData.image" :src="getMemberData.image.img_url" class="object-cover object-center h-full w-full"/>
            </div>
        </div>
          <button class="btn bg-theme-42 text-white rounded-3xl">
            {{ isFamProfile ? "หัวหน้าครอบครัว" : "หัวหน้าครัวเรือน" }}
          </button>
        </div>
        <div class="flex flex-col min-w-full md:min-w-0 md:flex-grow">
          <h3 class="text-xl text-theme-37 font-semibold mb-1">
            {{
              isFamProfile
                ? (information?.memberinfo?.head_member
                    ? `${information.memberinfo.head_member.title ?? ""}${information.memberinfo.head_member.name ?? ""} ${information.memberinfo.head_member.surname ?? ""}`.trim()
                    : "-")
                : `${
                    information?.household_head
                      ? information.household_head.title ?? ""
                      : ""
                  }${
                    information?.household_head
                      ? information.household_head.name ?? ""
                      : ""
                  } ${
                    information?.household_head
                      ? information.household_head.surname ?? ""
                      : ""
                  }${information?.household_head ? "" : "-"}`
            }}

            <!-- Static Data -->
          </h3>
          <span class="text-base font-normal text-theme-37 mb-1" v-if="isFamProfile == false"
            >รหัสประจำบ้าน
            {{ information.hh_code ? information.hh_code : "-" }}</span
          >
          <span class="text-base font-normal text-theme-37 mb-1" v-if="isFamProfile"
            >ประเภทครอบครัว: 
            {{ information.fam_type ? information.fam_type.desc : "-" }}</span
          >
          <!-- <div class="flex justify-start" v-if="isFamProfile">
        <div
          class="px-3 py-2 bg-theme-37 text-white inline-block rounded-md rounded-tl-none rounded-br-none"
        >
          {{ information.fam_type ? information.fam_type.desc : "ไม่มีข้อมูล" }}
        </div>
      </div> -->

          <p class="text-base text-theme-37 font-normal">
            {{ addressComputed }}
          </p>
          <hr class="mt-3" />
          <div class="flex flex-wrap justify-center items-center py-6">
            <div class="flex-grow my-2">
              <h5 class="text-sm font-semibold text-theme-37 mb-3">สมาชิก</h5>
              <div>
                <h3 class="inline text-5xl text-theme-1 mr-2 font-semibold">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.member_cnt
                            : "0"
                        }`
                      : `${
                          information.stats ? information.stats.member_cnt : "0"
                        }`
                  }}
                </h3>
                <p class="inline text-base text-theme-37">(คน)</p>
              </div>
            </div>
            <div class="flex-grow flex flex-col my-2">
              <h5 class="text-sm font-semibold text-theme-37 mb-6">เพศ</h5>
              <div class="flex items-center pb-1">
                <div
                  class="t-tooltip rounded-full bg-theme-41 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text">เพศชาย</span>
                  <img class="h-5 w-5 " src="@/assets/images/icon/male.png" />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.gender_male_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.gender_male_cnt
                            : "0"
                        }`
                  }}
                </p>
                <div
                  class="t-tooltip ml-3 rounded-full bg-theme-36 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text">เพศหญิง</span>
                  <img class="h-5 w-5" src="@/assets/images/icon/female.png" />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.gender_female_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.gender_female_cnt
                            : "0"
                        }`
                  }}
                </p>
              </div>
            </div>

            <div class="flex-grow flex flex-col my-2">
              <h5 class="text-sm font-semibold text-theme-37 mb-6">
                ช่วงวัย
              </h5>
              <div class="flex flex-wrap md:flex-row items-center pb-1">
                <div
                  class="t-tooltip rounded-full bg-theme-1 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text">เด็กเล็ก (0 - 6 ปี)</span>
                  <img
                    class="h-5 w-5 "
                    src="@/assets/images/icon/baby-boy.png"
                  />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.ageclass_infant_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.ageclass_infant_cnt
                            : "0"
                        }`
                  }}
                </p>
                <div
                  class="t-tooltip ml-3 rounded-full bg-theme-1 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text">เด็ก (6 ปีขึ้นไป - 12 ปี)</span>
                  <img class="h-5 w-5 " src="@/assets/images/icon/kid.png" />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.ageclass_child_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.ageclass_child_cnt
                            : "0"
                        }`
                  }}
                </p>
                <div
                  class="t-tooltip ml-3 rounded-full bg-theme-1 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text"
                    >เด็กโต/วัยรุ่น (12 ปีขึ้นไป - 18 ปี)</span
                  >
                  <img
                    class="h-5 w-5 "
                    src="@/assets/images/icon/teenager.png"
                  />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.ageclass_teenage_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.ageclass_teenage_cnt
                            : "0"
                        }`
                  }}
                </p>
                <div
                  class="t-tooltip ml-3 rounded-full bg-theme-1 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text"
                    >ผู้ใหญ่/วัยแรงงาน (18 ปีขึ้นไป - 59 ปี)</span
                  >
                  <img class="h-5 w-5 " src="@/assets/images/icon/man.png" />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.ageclass_adult_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.ageclass_adult_cnt
                            : "0"
                        }`
                  }}
                </p>
                <div
                  class="t-tooltip ml-3 rounded-full bg-theme-1 flex w-8 h-8 justify-center items-center"
                >
                  <span class="t-tooltip-text">ผู้สูงอายุ (60 ปีขึ้นไป)</span>
                  <img
                    class="h-5 w-5 "
                    src="@/assets/images/icon/old-man.png"
                  />
                </div>
                <p class="inline ml-2 mr-2 text-theme-37">:</p>
                <p class="inline text-theme-37">
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.ageclass_elderly_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.ageclass_elderly_cnt
                            : "0"
                        }`
                  }}
                </p>
              </div>
            </div>

            <div class="flex-grow flex flex-col my-2">
              <h5 class="text-sm font-semibold text-theme-37 mb-5">จำนวนผู้ป่วย-ผู้พิการ</h5>
              <div class="">
                <p class="text-theme-37">
                  ผู้พิการ :
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.is_disabled_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.is_disabled_cnt
                            : "0"
                        }`
                  }}
                  <!-- (มีบัตร : 1 ,ไม่มีบัตร : 1) -->
                  <!-- Static Data -->
                </p>
                <p class="text-theme-37">
                  ผู้ป่วยเรื้อรัง :
                  {{
                    isFamProfile
                      ? `${
                          information.memberinfo
                            ? information.memberinfo.chronic_disease_cnt
                            : "0"
                        }`
                      : `${
                          information.stats
                            ? information.stats.chronic_disease_cnt
                            : "0"
                        }`
                  }}
                  <!-- ผู้ป่วยติดเตียง : 2 -->
                  <!-- Static Data -->
                </p>
              </div>
            </div>
          </div>
          <template v-if="isFamProfile == false">
            <hr />
            <h2 class="text-lg my-4 text-theme-1 font-semibold">
              ที่อยู่อาศัย
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-2 mb-3">
              <div class="grid grid-cols-2 gap-1">
                <div class="flex items-center">
                  <p>ลักษณะครัวเรือน</p>
                </div>
                <div>
                  <div
                    class="inline-block rounded-lg px-2 py-1 border border-theme-1 text-theme-37"
                  >
                    {{
                      `${
                        information.hh_type
                          ? information.hh_type.desc
                          : "ไม่มีข้อมูล"
                      }`
                    }}
                  </div>
                </div>
                <div class="flex items-center">
                  <p>ความแข็งแรง</p>
                </div>
                <div>
                  <div
                    class="inline-block rounded-lg px-2 py-1 border border-theme-1 text-theme-37"
                  >
                    {{
                      information.house_solid
                        ? "มีความแข็งแรง"
                        : "ไม่มีความแข็งแรง"
                    }}
                  </div>
                </div>
              </div>
              <div class="grid grid-cols-2 gap-1">
                <div class="flex items-center">
                  <p>ที่อยู่อาศัยตั้งอยู่บน</p>
                </div>
                <div>
                  <div
                    class="inline-block rounded-lg px-2 py-1 border border-theme-1 text-theme-37"
                  >
                    {{
                      `${
                        information.house_type
                          ? information.house_type.desc
                          : "ไม่มีข้อมูล"
                      }`
                    }}
                  </div>
                </div>
                <div class="flex items-center">
                  <p>เหมาะกับเด็ก ผู้สูงอายุ และคนพิการ</p>
                </div>
                <div>
                  <div
                    class="inline-block rounded-lg px-2 py-1 border border-theme-1 text-theme-37"
                  >
                    {{ information.env_suitable ? "เหมาะสม" : "ไม่เหมาะสม" }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- <template v-if="!isFamProfile">
            <div class="mx-6">
              <TinySlider
                :options="{
                  controls: true,
                  items: 1,
                  responsive: {
                    1024: {
                      items: 3,
                    },
                    720: {
                      items: 2,
                    },
                  },
                }"
              >
                <div class="h-32 px-2" v-for="index in 6" :key="index">
                  <div class="h-full bg-gray-200 dark:bg-dark-1 rounded-md">
                    <h3
                      class="h-full font-medium flex items-center justify-center text-2xl"
                    >
                      {{ index }}
                    </h3>
                  </div>
                </div>
              </TinySlider>
            </div>
          </template> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed,ref,onMounted } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { getAllowActionByCurrRole, getCurrentRole } from "@/utils/get-roles"
// import AddFamilyModal from "@/components/add-family-modal/index.vue";
// import AddFamilyModal from "@/components/add-family-modal/index.vue";
// import AddHouseHoldModal from "@/components/add-house-hold-modal";

const props = defineProps({
  information: Object,
  familyProfile: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['showEditModal']);
const store = useStore()
const router = useRouter()
const getMemberData = ref([]);
const isFamProfile = ref(null)
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: 'btn btn-primary m-1',
    cancelButton: 'btn btn-outline-secondary m-1'
  },
  buttonsStyling: false
})
// const editModal = ref(false)
// const addFamilyModal = ref(false);
// const addHouseholdModal = ref(false);
// const editModal = ref(false)
onMounted(() => {
  getMember();
});

const addressComputed = computed(() => {
  let addressResult = "";
  if (props.information.hnum) addressResult += props.information.hnum;
  if (props.information.village_name)
    addressResult += ` ${props.information.village_name}`;
  if (props.information.moo) addressResult += ` หมู่${props.information.moo}`;
  if (props.information.soi) addressResult += ` ซอย${props.information.soi}`;
  if (props.information.road) addressResult += ` ถนน${props.information.road}`;
  if (props.information.tumbol_name)
    addressResult += ` ${
      props.information.province_name !== "กรุงเทพมหานคร" ? `ตำบล` : `แขวง`
    }${props.information.tumbol_name}`;
  if (props.information.amphur_name)
    addressResult += ` ${
      props.information.province_name !== "กรุงเทพมหานคร" ? `อำเภอ` : `เขต`
    }${props.information.amphur_name}`;
  if (props.information.province_name)
    addressResult += ` จังหวัด${props.information.province_name}`;
  if (props.information.postcode)
    addressResult += ` ${props.information.postcode}`;

  return addressResult;
});
const openEditFamilyModal = () =>{
  emit("showEditModal")
}
const getMember = async() => {
  try {
    await axios
        .post(`${process.env.VUE_APP_BASE_API}member/getMemberSurveyById `, {
          //id from get member
          member_nid: props.familyProfile ? props.information.fam_head : props.information.hh_head
        })
        .then((response) => {
          if (response.status === 200) {
            getMemberData.value = response.data
            isFamProfile.value = props.familyProfile ? props.familyProfile : false
          }
          else{
            Swal.fire({
              icon: "warning",
              text: "ระบบผิดพลาด",
            })
          }
        })
    
  } catch (error) {
    console.log(error.message)
  }
};
const deleteProfile = ()=>{
  const token = store.getters["userAuth/getToken"];
  swalCustom.fire({
    text:"ยืนยันลบข้อมูล",
    icon:"warning",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
  }).then(async (result)=>{
    if(result.isConfirmed){
      if(props.familyProfile ? !getMemberData.value.is_hh_head : true){
        //delete hh update status api hh , delete fam update api fam 
        const config = {
          url: `${process.env.VUE_APP_BASE_API}${props.familyProfile?'family':'household'}/${props.information._id}`,
          method: "PUT",
          headers:{
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data:{
            update:{
              status: "removed",
              modified_by: store.getters["userInfo/getUserInfoForApi"]
            }
          }
        }
        try{
          const response = await axios(config)
          if(response){
            swalCustom.fire({
              text:"สำเร็จ",
              icon: 'success',
              timer: 3000,
              confirmButtonText: "ปิด",
            }).then(() => {
              router.push({
                name: `${props.familyProfile?'family-page':'main-house-hold'}`,
              })
            });
          }
        }
        catch(error){
          swalCustom.fire({
            text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
            icon: "warning",
            //timer: 3000, //timeOut for auto-close
            confirmButtonText: "ปิด",
          });
          console.log(error);
        }
      }
      else{
        swalCustom.fire({
          text: "ไม่สามารถลบได้",
          icon: "warning",
          //timer: 3000, //timeOut for auto-close
          confirmButtonText: "ปิด",
        });
      }
    }
  })
}
const currentUser = computed(()=>{
  return store.getters["userAuth/getUsername"]
})
</script>
